import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";

import { GlobalContext } from "../../providers/GlobalProvider";
import { Toast } from "../../utils/toast";
import { api } from "../../api/api";
import "./style.css";

export function LoginPage() {
  const navigate = useNavigate();
  const { setStudent } = useContext(GlobalContext);
  const [user, setUser] = useState({
    cpf: "",
    password: "",
  });

  async function auth() {
    try {
      if (!user.cpf || !user.password) {
        return Toast.warning("Preencha todos dados para acessar.");
      }

      const response = await api.post("/api/v1/auth", user);

      setStudent(response.data.student[0]);
      localStorage.setItem("token", response.data.token.token);
      navigate("/home");
    } catch (error) {
      Toast.warning(
        "Verifique os dados e tente novamente.",
        "Login ou Senha inválidos",
      );
    }
  }
  return (
    <div className="login-page">
      <div className="login-showcase">
        <div className="login-showcase-content">
          <span>Portal do aluno</span>
          <h1>Seu aprendizado continua aqui.</h1>
          <p>Acesse cursos, matrículas e sua agenda em um único lugar.</p>
          <div className="login-highlight">
            <strong>Cursinho Ômega</strong>
            <small>Educação que prepara para o futuro.</small>
          </div>
        </div>
      </div>
      <main className="login-panel">
        <div className="login-card">
          <img className="login-logo" src="/img/omega.7041f9d3.png" alt="Cursinho Ômega" />
          <div className="login-heading">
            <span>Bem-vindo de volta</span>
            <h2>Acesse sua conta</h2>
            <p>Use seu CPF e sua senha para entrar.</p>
          </div>

          <div className="login-field">
            <label htmlFor="login-cpf">CPF</label>
            <input id="login-cpf" value={user.cpf} onChange={(e) => setUser({ ...user, cpf: e.target.value })} type="text" className="form-control" placeholder="000.000.000-00" />
          </div>
          <div className="login-field">
            <label htmlFor="login-password">Senha</label>
            <input id="login-password" value={user.password} onChange={(e) => setUser({ ...user, password: e.target.value })} type="password" className="form-control" placeholder="Digite sua senha" />
          </div>

          <button className="btn btn-primary w-100 login-submit" onClick={() => auth()}>Acessar portal</button>
          <div className="login-divider"><span>ou</span></div>
          <button className="btn btn-outline-primary w-100" onClick={() => navigate("/register")}>Criar cadastro</button>
        </div>
      </main>
    </div>
  );
}
